import Vue from 'vue'
import Vuex from 'vuex'

// Store For Template Theme
import state from "./state"
import getters from "./getters"
import mutations from "./mutations"
import actions from "./actions"

// app Store
import auth from './storeModules/auth'

/**
 * Admin Store
 */
import brokers from './storeModules/broker'
import promos from './storeModules/promos'
import brokerCommissions from './storeModules/brokerCommission'

Vue.use(Vuex)

export default new Vuex.Store({

    // Template Theme Store
    getters,
    mutations,
    state,
    actions,
    strict: process.env.NODE_ENV !== 'production',

    modules: {
      auth,
      brokers,
      promos,
      brokerCommissions
    },
})
